var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSuccessAnswer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.80273 11.2668V15.4174H5.50626C5.93556 15.4159 6.36239 15.4815 6.77093 15.6116L7.60774 15.8806C8.26001 16.0874 8.9408 16.1933 9.62592 16.1944H16.1235C16.3641 16.1944 16.596 16.1054 16.7733 15.9449C16.9507 15.7845 17.0606 15.5642 17.0814 15.3277L17.994 8.4798C18.0065 8.39127 17.9995 8.30114 17.9736 8.21549C17.9477 8.12984 17.9035 8.05069 17.8439 7.98338C17.7843 7.91607 17.7107 7.86219 17.6281 7.82537C17.5456 7.78855 17.456 7.76966 17.3654 7.76997H13.1208C13.008 7.76899 12.9001 7.72408 12.8207 7.64501C12.7413 7.56595 12.6967 7.45914 12.6967 7.34782V4.17603C12.6967 4.06141 12.6738 3.94791 12.6292 3.84205C12.5846 3.7362 12.5193 3.64007 12.437 3.55919C12.3547 3.47831 12.257 3.41427 12.1495 3.37075C12.042 3.32723 11.9269 3.30507 11.8107 3.30557H10.3529L8.60736 7.2731C8.48973 7.54068 8.31935 7.78251 8.10614 7.98454C7.89293 8.18656 7.64114 8.34476 7.36541 8.44991L6.64977 8.72263C6.25308 8.87137 5.83217 8.94733 5.40781 8.94679H2",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessAnswer);
export default ForwardRef;